import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "border border-gray-200 rounded-md divide-y divide-gray-200" }
const _hoisted_2 = { class: "flex-1 flex" }
const _hoisted_3 = { class: "flex-1 ml-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = { class: "font-semibold" }
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = { class: "font-semibold" }
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = { class: "font-semibold" }
const _hoisted_14 = { class: "font-semibold" }
const _hoisted_15 = { class: "font-semibold" }
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = { class: "font-semibold" }
const _hoisted_18 = { class: "font-semibold" }
const _hoisted_19 = { class: "font-semibold" }
const _hoisted_20 = { class: "font-semibold" }
const _hoisted_21 = { class: "font-semibold" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "ml-2 flex-shrink-0 text-gray-500 text-left sm:ml-4" }

import { PropType } from 'vue';
import SpfQuantifier from '@/components/records/SpfQuantifier.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import { Qualifier, Term } from '@/model/Spf';


export default /*@__PURE__*/_defineComponent({
  __name: 'SpfRecord',
  props: {
  terms: {
    type: Object as PropType<Array<Term>>,
    required: true,
  },
  domain: {
    type: String,
    required: true,
  },
},
  setup(__props) {



function encodeQualifier(qualifier: Qualifier) {
  switch (qualifier) {
    case 'Pass': return '+';
    case 'Fail': return '-';
    case 'Softfail': return '~';
    case 'Neutral': return '?';
    case 'None': return '';
    default: return '';
  }
}

function sortTerms(l: Term, r: Term) {
  function toValue(t: Term) {
    if ('Directive' in t) return 1;
    if ('Redirect' in t) return 2;
    if ('Exp' in t) return 3;
    if ('UnknownModifier' in t) return 4;
    return 0;
  }
  return toValue(l) - toValue(r);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ol", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...__props.terms].sort(sortTerms), (term, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        class: "pl-3 pr-4 py-3 flex flex-col justify-between sm:flex-row sm:items-center"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            (term.Directive)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (index !== 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Or else, "))
                    : _createCommentVNode("", true),
                  (term.Directive.mechanism.All)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("span", {
                          class: _normalizeClass({ capitalize: index === 0 })
                        }, "mark", 2),
                        _cache[0] || (_cache[0] = _createTextVNode(" the email as ", -1)),
                        _createVNode(SpfQuantifier, {
                          qualifier: term.Directive.qualifier
                        }, null, 8, ["qualifier"]),
                        _cache[1] || (_cache[1] = _createTextVNode(". ", -1))
                      ], 64))
                    : (term.Directive.mechanism.Include)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["text-cyan-600 font-semibold", { capitalize: index === 0 }])
                          }, "include", 2),
                          _cache[2] || (_cache[2] = _createTextVNode(" the SPF record at ", -1)),
                          (term.Directive.mechanism.Include.domain.includes('%'))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(term.Directive.mechanism.Include.domain), 1))
                            : (_openBlock(), _createBlock(DnsRecordsLink, {
                                key: 1,
                                domain: term.Directive.mechanism.Include.domain,
                                page: "SPF",
                                class: "text-blue-600 hover:text-blue-800 font-semibold"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(term.Directive.mechanism.Include.domain), 1)
                                ]),
                                _: 2
                              }, 1032, ["domain"])),
                          _cache[3] || (_cache[3] = _createTextVNode(" and ", -1)),
                          _createVNode(SpfQuantifier, {
                            qualifier: term.Directive.qualifier
                          }, null, 8, ["qualifier"]),
                          _cache[4] || (_cache[4] = _createTextVNode(" if it matches the sender's IP. ", -1))
                        ], 64))
                      : (term.Directive.mechanism.A)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createVNode(SpfQuantifier, {
                              qualifier: term.Directive.qualifier,
                              class: _normalizeClass({ capitalize: index === 0 })
                            }, null, 8, ["qualifier", "class"]),
                            _cache[11] || (_cache[11] = _createTextVNode(" if the email sender's IP is in the ", -1)),
                            _createVNode(DnsRecordsLink, {
                              domain: term.Directive.mechanism.A.domain ? term.Directive.mechanism.A.domain : __props.domain,
                              page: "a",
                              class: "text-blue-600 hover:text-blue-800 font-semibold"
                            }, {
                              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createTextVNode("A", -1)
                              ]))]),
                              _: 1
                            }, 8, ["domain"]),
                            (term.Directive.mechanism.A.ip4cidr)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[6] || (_cache[6] = _createTextVNode(" (with CIDR ", -1)),
                                  _createElementVNode("span", _hoisted_6, "/" + _toDisplayString(term.Directive.mechanism.A.ip4cidr), 1),
                                  _cache[7] || (_cache[7] = _createTextVNode(")", -1))
                                ], 64))
                              : _createCommentVNode("", true),
                            _cache[12] || (_cache[12] = _createTextVNode(" or ", -1)),
                            _createVNode(DnsRecordsLink, {
                              domain: term.Directive.mechanism.A.domain ? term.Directive.mechanism.A.domain : __props.domain,
                              page: "aaaa",
                              class: "text-blue-600 hover:text-blue-800 font-semibold"
                            }, {
                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createTextVNode("AAAA", -1)
                              ]))]),
                              _: 1
                            }, 8, ["domain"]),
                            (term.Directive.mechanism.A.ip6cidr)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _cache[9] || (_cache[9] = _createTextVNode(" (with CIDR ", -1)),
                                  _createElementVNode("span", _hoisted_7, "/" + _toDisplayString(term.Directive.mechanism.A.ip6cidr), 1),
                                  _cache[10] || (_cache[10] = _createTextVNode(")", -1))
                                ], 64))
                              : _createCommentVNode("", true),
                            _cache[13] || (_cache[13] = _createTextVNode(" records of ", -1)),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(term.Directive.mechanism.A.domain ? term.Directive.mechanism.A.domain : __props.domain), 1),
                            _cache[14] || (_cache[14] = _createTextVNode(". ", -1))
                          ], 64))
                        : (term.Directive.mechanism.MX)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              _createVNode(SpfQuantifier, {
                                qualifier: term.Directive.qualifier,
                                class: _normalizeClass({ capitalize: index === 0 })
                              }, null, 8, ["qualifier", "class"]),
                              _cache[22] || (_cache[22] = _createTextVNode(" if the email sender's IP is in the MX records ", -1)),
                              (term.Directive.mechanism.MX.ip4cidr && term.Directive.mechanism.MX.ip6cidr)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[15] || (_cache[15] = _createTextVNode("(with CIDR ", -1)),
                                    _createElementVNode("span", _hoisted_9, "/" + _toDisplayString(term.Directive.mechanism.MX.ip4cidr), 1),
                                    _cache[16] || (_cache[16] = _createTextVNode(" for IPv4 and ", -1)),
                                    _createElementVNode("span", _hoisted_10, "/" + _toDisplayString(term.Directive.mechanism.MX.ip6cidr), 1),
                                    _cache[17] || (_cache[17] = _createTextVNode(" for IPv6) ", -1))
                                  ], 64))
                                : (term.Directive.mechanism.MX.ip4cidr)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _cache[18] || (_cache[18] = _createTextVNode("(with CIDR ", -1)),
                                      _createElementVNode("span", _hoisted_11, "/" + _toDisplayString(term.Directive.mechanism.MX.ip4cidr), 1),
                                      _cache[19] || (_cache[19] = _createTextVNode(" for IPv4) ", -1))
                                    ], 64))
                                  : (term.Directive.mechanism.MX.ip6cidr)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _cache[20] || (_cache[20] = _createTextVNode("(with CIDR ", -1)),
                                        _createElementVNode("span", _hoisted_12, "/" + _toDisplayString(term.Directive.mechanism.MX.ip6cidr), 1),
                                        _cache[21] || (_cache[21] = _createTextVNode(" for IPv6) ", -1))
                                      ], 64))
                                    : _createCommentVNode("", true),
                              _cache[23] || (_cache[23] = _createTextVNode("of ", -1)),
                              _createElementVNode("span", _hoisted_13, _toDisplayString(term.Directive.mechanism.MX.domain ? term.Directive.mechanism.MX.domain : __props.domain), 1),
                              _cache[24] || (_cache[24] = _createTextVNode(". ", -1))
                            ], 64))
                          : (term.Directive.mechanism.PTR)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                _createVNode(SpfQuantifier, {
                                  qualifier: term.Directive.qualifier,
                                  class: _normalizeClass({ capitalize: index === 0 })
                                }, null, 8, ["qualifier", "class"]),
                                _cache[26] || (_cache[26] = _createTextVNode(" if a ", -1)),
                                _createVNode(_component_router_link, {
                                  to: "/ptr-lookup/",
                                  class: "text-blue-600 hover:text-blue-800 font-semibold"
                                }, {
                                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                    _createTextVNode("reverse lookup", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[27] || (_cache[27] = _createTextVNode(" of the email sender's IP resolves to ", -1)),
                                _createElementVNode("span", _hoisted_14, _toDisplayString(term.Directive.mechanism.PTR.domain ? term.Directive.mechanism.PTR.domain : __props.domain), 1),
                                _cache[28] || (_cache[28] = _createTextVNode(". ", -1))
                              ], 64))
                            : (term.Directive.mechanism.IP4)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                  (term.Directive.mechanism.IP4.ipStart === term.Directive.mechanism.IP4.ipEnd)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(SpfQuantifier, {
                                          qualifier: term.Directive.qualifier,
                                          class: _normalizeClass({ capitalize: index === 0 })
                                        }, null, 8, ["qualifier", "class"]),
                                        _cache[29] || (_cache[29] = _createTextVNode(" if the email sender's IP is ", -1)),
                                        _createElementVNode("span", _hoisted_15, _toDisplayString(term.Directive.mechanism.IP4.ip), 1),
                                        _cache[30] || (_cache[30] = _createTextVNode(". ", -1))
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createVNode(SpfQuantifier, {
                                          qualifier: term.Directive.qualifier,
                                          class: _normalizeClass({ capitalize: index === 0 })
                                        }, null, 8, ["qualifier", "class"]),
                                        _cache[31] || (_cache[31] = _createTextVNode(" if the email sender's IP is between ", -1)),
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(term.Directive.mechanism.IP4.ipStart), 1),
                                        _cache[32] || (_cache[32] = _createTextVNode(" and ", -1)),
                                        _createElementVNode("span", _hoisted_17, _toDisplayString(term.Directive.mechanism.IP4.ipEnd), 1),
                                        _cache[33] || (_cache[33] = _createTextVNode(". ", -1))
                                      ], 64))
                                ], 64))
                              : (term.Directive.mechanism.IP6)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                    (term.Directive.mechanism.IP6.ipStart === term.Directive.mechanism.IP6.ipEnd)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createVNode(SpfQuantifier, {
                                            qualifier: term.Directive.qualifier,
                                            class: _normalizeClass({ capitalize: index === 0 })
                                          }, null, 8, ["qualifier", "class"]),
                                          _cache[34] || (_cache[34] = _createTextVNode(" if the email sender's IP is ", -1)),
                                          _createElementVNode("span", _hoisted_18, _toDisplayString(term.Directive.mechanism.IP6.ip), 1),
                                          _cache[35] || (_cache[35] = _createTextVNode(". ", -1))
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createVNode(SpfQuantifier, {
                                            qualifier: term.Directive.qualifier,
                                            class: _normalizeClass({ capitalize: index === 0 })
                                          }, null, 8, ["qualifier", "class"]),
                                          _cache[36] || (_cache[36] = _createTextVNode(" if the email sender's IP is between ", -1)),
                                          _createElementVNode("span", _hoisted_19, _toDisplayString(term.Directive.mechanism.IP6.ipStart), 1),
                                          _cache[37] || (_cache[37] = _createTextVNode(" and ", -1)),
                                          _createElementVNode("span", _hoisted_20, _toDisplayString(term.Directive.mechanism.IP6.ipEnd), 1),
                                          _cache[38] || (_cache[38] = _createTextVNode(". ", -1))
                                        ], 64))
                                  ], 64))
                                : (term.Directive.mechanism.Exists)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                      _createVNode(SpfQuantifier, {
                                        qualifier: term.Directive.qualifier,
                                        class: _normalizeClass({ capitalize: index === 0 })
                                      }, null, 8, ["qualifier", "class"]),
                                      _cache[39] || (_cache[39] = _createTextVNode(" if an A record exists for ", -1)),
                                      _createElementVNode("span", _hoisted_21, _toDisplayString(term.Directive.mechanism.Exists.domain), 1),
                                      _cache[40] || (_cache[40] = _createTextVNode(". ", -1))
                                    ], 64))
                                  : _createCommentVNode("", true)
                ], 64))
              : (term.Exp)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (index !== 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, "And "))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass({ capitalize: index === 0 })
                    }, "query", 2),
                    _cache[41] || (_cache[41] = _createTextVNode()),
                    _createVNode(DnsRecordsLink, {
                      domain: term.Modifier.Exp.domain,
                      page: "SPF",
                      class: "text-blue-600 hover:text-blue-800 font-semibold"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(term.Modifier.Exp.domain), 1)
                      ]),
                      _: 2
                    }, 1032, ["domain"]),
                    _cache[42] || (_cache[42] = _createTextVNode(" for an explanation when the SPF check fails. ", -1))
                  ], 64))
                : (term.Redirect)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (index !== 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Or else, "))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass(["text-cyan-600 font-semibold", { capitalize: index === 0 }])
                      }, "redirect", 2),
                      _cache[43] || (_cache[43] = _createTextVNode(" SPF checking to ", -1)),
                      (term.Redirect.domain.includes('%'))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(term.Redirect.domain), 1)
                          ], 64))
                        : (_openBlock(), _createBlock(DnsRecordsLink, {
                            key: 2,
                            domain: term.Redirect.domain,
                            page: "SPF",
                            class: "text-blue-600 hover:text-blue-800 font-semibold"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(term.Redirect.domain), 1)
                            ]),
                            _: 2
                          }, 1032, ["domain"])),
                      _cache[44] || (_cache[44] = _createTextVNode(". ", -1))
                    ], 64))
                  : (term.UnknownModifier)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (index !== 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "And "))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", {
                          class: _normalizeClass({ capitalize: index === 0 })
                        }, "ignore", 2),
                        _cache[45] || (_cache[45] = _createTextVNode(" this unknown modifier. ", -1))
                      ], 64))
                    : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          (term.Directive)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (term.Directive.mechanism.All)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(encodeQualifier(term.Directive.qualifier)) + "all ", 1)
                    ], 64))
                  : (term.Directive.mechanism.Include)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(encodeQualifier(term.Directive.qualifier)) + "include:" + _toDisplayString(term.Directive.mechanism.Include.domain), 1)
                      ], 64))
                    : (term.Directive.mechanism.A)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(encodeQualifier(term.Directive.qualifier)) + "a" + _toDisplayString(term.Directive.mechanism.A.domain ? ':' + term.Directive.mechanism.A.domain : '') + _toDisplayString(term.Directive.mechanism.A.ip4cidr ? `/${term.Directive.mechanism.A.ip4cidr}` : '') + _toDisplayString(term.Directive.mechanism.A.ip6cidr ? `//${term.Directive.mechanism.A.ip6cidr}` : ''), 1)
                        ], 64))
                      : (term.Directive.mechanism.MX)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createTextVNode(_toDisplayString(encodeQualifier(term.Directive.qualifier)) + "mx" + _toDisplayString(term.Directive.mechanism.MX.domain ? ':' + term.Directive.mechanism.MX.domain : '') + _toDisplayString(term.Directive.mechanism.MX.ip4cidr ? `/${term.Directive.mechanism.MX.ip4cidr}` : '') + _toDisplayString(term.Directive.mechanism.MX.ip6cidr ? `//${term.Directive.mechanism.MX.ip6cidr}` : ''), 1)
                          ], 64))
                        : (term.Directive.mechanism.PTR)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              _createTextVNode(_toDisplayString(encodeQualifier(term.Directive.qualifier)) + "ptr" + _toDisplayString(term.Directive.mechanism.PTR.domain ? ':' + term.Directive.mechanism.PTR.domain : ''), 1)
                            ], 64))
                          : (term.Directive.mechanism.IP4)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                _createTextVNode(_toDisplayString(encodeQualifier(term.Directive.qualifier)) + "ip4:" + _toDisplayString(term.Directive.mechanism.IP4.ipStart) + _toDisplayString(term.Directive.mechanism.IP4.cidr ? `/${term.Directive.mechanism.IP4.cidr}` : ''), 1)
                              ], 64))
                            : (term.Directive.mechanism.IP6)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                  _createTextVNode(_toDisplayString(encodeQualifier(term.Directive.qualifier)) + "ip6:" + _toDisplayString(term.Directive.mechanism.IP6.ipStart) + _toDisplayString(term.Directive.mechanism.IP6.cidr ? `/${term.Directive.mechanism.IP6.cidr}` : ''), 1)
                                ], 64))
                              : (term.Directive.mechanism.Exists)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                    _createTextVNode(_toDisplayString(encodeQualifier(term.Directive.qualifier)) + "exists:" + _toDisplayString(term.Directive.mechanism.Exists.domain), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (term.Exp)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" exp=" + _toDisplayString(term.Exp.domain), 1)
              ], 64))
            : (term.Redirect)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(" redirect=" + _toDisplayString(term.Redirect.domain), 1)
                ], 64))
              : (term.UnknownModifier)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode(_toDisplayString(term.UnknownModifier.name) + "=" + _toDisplayString(term.UnknownModifier.macroString), 1)
                  ], 64))
                : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}
}

})